import { c as _c } from "react/compiler-runtime";
import { getToken, useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { useRouter } from "next/router";
import type { ComponentProps, ReactNode } from "react";
type VillaHostSignupButtonProperties = {
  className?: string;
  children?: ReactNode;
} & Pick<ComponentProps<typeof Button>, "size">;
export const VillaHostSignupButton = t0 => {
  const $ = _c(8);
  const {
    className,
    size,
    children: t1
  } = t0;
  const children = t1 === undefined ? "\u062B\u0628\u062A \u0646\u0627\u0645 \u0648 \u0648\u0631\u0648\u062F" : t1;
  const router = useRouter();
  const {
    isLoggedIn
  } = useLoginStatus();
  let t2;
  if ($[0] !== isLoggedIn || $[1] !== router) {
    t2 = () => {
      const myVillaUrl = process.env.NEXT_PUBLIC_BASE_URL_MY_VILLA;
      const redirectToMyVilla = (accessToken, refreshToken) => {
        if (!myVillaUrl) {
          return;
        }
        const storedTokens = getToken();
        const redirectUrl = new URL(myVillaUrl);
        const stToken = accessToken || storedTokens.stToken;
        const stRefreshToken = refreshToken || storedTokens.refreshToken;
        if (stToken) {
          redirectUrl.searchParams.set("st_token", stToken);
        }
        if (stRefreshToken) {
          redirectUrl.searchParams.set("st_refresh_token", stRefreshToken);
        }
        window.location.href = redirectUrl.toString();
      };
      if (isLoggedIn && myVillaUrl) {
        redirectToMyVilla();
        return;
      }
      const handleLoginModalEnd = event => {
        const {
          accessToken: accessToken_0,
          refreshToken: refreshToken_0
        } = (event as CustomEvent<Record<string, string | undefined>>).detail || {};
        cleanupLoginListeners();
        if (myVillaUrl) {
          redirectToMyVilla(accessToken_0, refreshToken_0);
        }
      };
      const cleanupLoginListeners = () => {
        document.removeEventListener("onLoginModalEnd", handleLoginModalEnd);
        document.removeEventListener("onLoginModalClose", cleanupLoginListeners);
      };
      document.addEventListener("onLoginModalEnd", handleLoginModalEnd);
      document.addEventListener("onLoginModalClose", cleanupLoginListeners);
      router.push({
        pathname: router.pathname,
        query: {
          ...router.query,
          login_step: "phone-number"
        }
      }, undefined, {
        shallow: true,
        scroll: false
      });
    };
    $[0] = isLoggedIn;
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openSignupModal = t2;
  let t3;
  if ($[3] !== children || $[4] !== className || $[5] !== openSignupModal || $[6] !== size) {
    t3 = <Button size={size} color="neutral" className={className} onClick={openSignupModal}>{children}</Button>;
    $[3] = children;
    $[4] = className;
    $[5] = openSignupModal;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};